import { initMain } from "./vue/controllers/main.js";
import { header } from "./vue/controllers/header.js";

import lazyload from "./features/lazy-load.js";
import stickyScroll from "./features/sticky-scroll.js";
import { topicMixin } from "./vue/mixins/lrplus.js";
import AddTopic from "./vue/components/add-topic/AddTopic.vue";

lazyload();
stickyScroll();
const mixins = [topicMixin];

initMain(mixins, {
  SectionPager: () => import("./vue/components/section-pager/SectionPager.vue"),
  SubscribeModal: () =>
    import("./vue/components/subscribe-modal/SubscribeModal.vue"),
  TrendsHorizontal: () =>
    import("./vue/components/trends/TrendsHorizontal.vue"),
  PresidentialElectionsSecondRound: () =>
    import(
      "./vue/components/presidential-elections-second-round/PresidentialElectionsSecondRound.vue"
    ),
  AddTopic,
});
header();
